// extracted by mini-css-extract-plugin
export default {"caption_col":"vt_vu","caption":"vt_vv","seat":"vt_vw","win":"vt_uK"};